import { Controller } from "@hotwired/stimulus"
import consumer from "../action-cable-consumer"

export default class extends Controller {
  static targets = ["content"]

  static values = {
    versionId: String,
    pollingEnabled: { type: Boolean, default: true }
  }

  connect() {
    // Connect to WS, waiting to receive an event when doc is ready.
    this.initChannel()
    // In case the WS fails in anyway we try with standard HTTP
    // polling every 5 seconds.
    this.initPolling()
  }

  initChannel() {
    const self = this

    consumer.subscriptions.create(
      {
        channel: "VersionCable::LoadingChannel",
        versionId: self.versionIdValue
      }, {
        // Called when the subscription is ready for use on the server.
        connected() {
          self.disablePolling()
        },
        // Called when the WebSocket connection is closed.
        disconnected() {
          self.enablePolling()
        },
        // Called when the subscription is rejected by the server.
        rejected() {
          self.enablePolling()
        },
        // Called when the server sends an event through the channel
        received: function(data) {
          if (data.reload) {
            document.location.reload()
          }
        }
      }
    )
  }

  initPolling() {
    const self = this

    if (self.pollingEnabledValue) {
      this.polling = setTimeout(() => {
        fetch(document.body.dataset.docRootUrl, {method: "HEAD"}).then(
          (response) => {
            switch (response?.status) {
            case 202:
              self.initPolling()
              break
            case 200:
              document.location.reload()
              break
            }
          }
        )
      }, 5000)
    }
  }

  enablePolling() {
    this.pollingEnabledValue = true
    if (!this.polling) {
      this.initPolling()
    }
  }

  disablePolling() {
    if (this.polling) {
      clearTimeout(this.polling)
    }
    this.pollingEnabledValue = false
  }
}
